"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const merge_1 = __importDefault(require("lodash/merge"));
const ObjectivesClient_1 = require("client/ObjectivesClient");
const ToastContext_1 = require("context/ToastContext");
const UserContext_1 = require("context/UserContext");
const useClickOutside_1 = __importDefault(require("hooks/useClickOutside"));
const DateUtils_1 = require("utils/DateUtils");
const HelperUtils_1 = require("utils/HelperUtils");
const ObjectivesHelper_1 = require("utils/ObjectivesHelper");
const Avatar_1 = __importDefault(require("components/design-system/Avatar"));
const Modal_1 = __importDefault(require("components/design-system/Modal"));
const AvatarGroup_1 = __importDefault(require("components/design-system/avatar-group/AvatarGroup"));
const InlineDialogSelectMultipleUser_1 = __importDefault(require("components/inline-dialog/InlineDialogSelectMultipleUser"));
const ObjectiveProgressSummaryPreview_1 = __importDefault(require("components/objectives/progress-summary/ObjectiveProgressSummaryPreview"));
const ToastNotif_1 = __importDefault(require("components/shared/ToastNotif"));
const TruncateParagraph_1 = __importDefault(require("src/components/shared/TruncateParagraph"));
const ObjectiveProgressSummaryModal = ({ setShowModal, filter, owner, extraFilter, placementId, parentObjective }) => {
    const [objectives, setObjectives] = (0, react_1.useState)([]);
    const [overallProgress, setOverallProgress] = (0, react_1.useState)({});
    const [parentObjectiveOwners, setParentObjectiveOwners] = (0, react_1.useState)([]);
    const [receivers, setReceivers] = (0, react_1.useState)([]);
    const [selectedUsers, setSelectedUsers] = (0, react_1.useState)([{}]);
    const [showDialog, setShowDialog] = (0, react_1.useState)(false);
    const [showPreview, setShowPreview] = (0, react_1.useState)(false);
    const [showToastNotif, setShowToastNotif] = (0, react_1.useState)(false);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [inlineDialogHorizontalMargin, setInlineDialogHorizontalMargin] = (0, react_1.useState)(0);
    const { user } = (0, UserContext_1.useUser)();
    const { addToast } = (0, ToastContext_1.useToastContext)();
    const receiverRef = (0, react_1.useRef)(null);
    const inlineDialogRef = (0, react_1.useRef)(null);
    (0, useClickOutside_1.default)(inlineDialogRef, () => setShowDialog(false));
    const onClickExport = async () => {
        if (receivers?.length === 0) {
            setShowToastNotif(true);
            setTimeout(() => setShowToastNotif(false), 3000);
        }
        else {
            setShowToastNotif(false);
            setIsLoading(true);
            await getObjectives();
            await getOverallProgress();
            setIsLoading(false);
            setShowPreview(true);
        }
    };
    const getObjectives = async () => {
        const mergedFilter = (0, merge_1.default)((0, ObjectivesHelper_1.restructureFilter)(filter), extraFilter);
        mergedFilter.assigneeId =
            mergedFilter?.assigneeId?.length > 0
                ? mergedFilter?.assigneeId?.map((id) => parseInt(id))
                : mergedFilter?.assigneeId;
        const allParams = {
            reviewsVisibility: 1,
            limit: parentObjective ? 24 : 25,
            ...(placementId && { placementId: placementId }),
            ...(parentObjective && {
                parentId: parentObjective?.id,
                sortColumn: 'start_date',
                sortDirection: 'asc',
                caseInsensitive: false,
                goals: 'individual'
            }),
            ...mergedFilter
        };
        const { data } = await (0, ObjectivesClient_1.getListObjectives)(allParams);
        if (data) {
            setObjectives(data);
        }
    };
    const getOverallProgress = async () => {
        const allParams = {
            assigneeId: owner?.id,
            parentNotAssignedTo: user?.id,
            periodBegin: (0, DateUtils_1.formatTimezone)(`${new Date().getFullYear()}-01-01`, 'start'),
            periodEndBefore: (0, DateUtils_1.formatTimezone)(`${new Date().getFullYear()}-12-31`, 'end'),
            state: ['running', 'completed', 'reviewed', 'draft', 'edited'],
            type: ['goal', 'annual_goal'],
            ...(placementId && { placementId: placementId }),
            ...(!placementId &&
                owner?.placementId && { placementId: owner?.placementId })
        };
        const { data } = await (0, ObjectivesClient_1.getObjectivesCount)(allParams);
        if (data) {
            setOverallProgress(data);
        }
    };
    const setToast = (type) => {
        const userName = receivers.length == 1
            ? receivers?.[0]?.name
            : receivers?.map((user) => user?.name)?.join(', ');
        let message = '';
        switch (type) {
            case 'info':
                message = `Processing ${owner?.id === user?.id ? 'your' : owner?.name + "'s"} objective summary`;
                break;
            case 'success':
                message = `The summary will be sent to receiver${receivers?.length === 1 ? "'s" : "s'"} WhatsApp account`;
                break;
            case 'error':
                message = [
                    `Export to ${userName} failed due to no WhatsApp account registered.`,
                    react_1.default.createElement("br", { key: "br" }),
                    'Please add it first then try again.'
                ];
                break;
        }
        addToast({
            title: 'Exporting Image',
            msg: message,
            type: type
        });
    };
    const handleChangeSelectedUsers = (newSelectedUsers) => {
        setReceivers(newSelectedUsers?.map((user) => user?.user));
        setSelectedUsers(newSelectedUsers);
    };
    (0, react_1.useEffect)(() => {
        setReceivers([user]);
        setSelectedUsers([
            {
                user: user,
                userId: user?.id
            }
        ]);
    }, [user]);
    (0, react_1.useEffect)(() => {
        if (parentObjective) {
            const tempOwners = [];
            parentObjective?.involvements?.map((involvement) => {
                if (involvement?.role === 'assignee') {
                    tempOwners?.push(involvement?.user);
                }
            });
            setParentObjectiveOwners(tempOwners);
        }
    }, [parentObjective]);
    (0, react_1.useEffect)(() => {
        typeof receiverRef?.current?.clientWidth == 'number' &&
            setInlineDialogHorizontalMargin(receiverRef?.current?.clientWidth);
    }, [receiverRef?.current?.clientWidth]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Modal_1.default, { minWidth: 400, onClose: () => setShowModal(false), closeOnClickOutside: false, customClass: !isLoading && showPreview ? 'hidden' : '' },
            react_1.default.createElement(Modal_1.default.Header, { title: (0, HelperUtils_1.getObjectiveLocale)('Objective Progress Summary'), onClose: () => setShowModal(false), useBorder: false }),
            react_1.default.createElement(Modal_1.default.Body, null,
                react_1.default.createElement("div", { className: "px-[24px] py-[4px] w-full" },
                    react_1.default.createElement("p", { className: "typography-paragraph text-n-800" }, (0, HelperUtils_1.getObjectiveLocale)('Please check the detail below before exporting.')),
                    react_1.default.createElement("div", { className: "flex my-[20px]" },
                        react_1.default.createElement("div", { className: "w-[166px] mr-[24px]" },
                            react_1.default.createElement("p", { className: "typography-h200 text-n-900 capitalize mb-[8px]" }, (0, HelperUtils_1.getObjectiveLocale)('Owner')),
                            parentObjective && parentObjectiveOwners?.length > 1 ? (react_1.default.createElement(AvatarGroup_1.default, { avatars: parentObjectiveOwners })) : (react_1.default.createElement("div", { className: "flex item-center" },
                                react_1.default.createElement(Avatar_1.default, { name: owner?.name, src: owner?.profilePicture, size: 24 }),
                                react_1.default.createElement(TruncateParagraph_1.default, { className: "typography-paragraph text-n-900 max-w-[132px] ml-[8px]" }, owner?.name)))),
                        react_1.default.createElement("div", { ref: receiverRef },
                            react_1.default.createElement("p", { className: "typography-h200 text-n-900 capitalize mb-[8px]" }, (0, HelperUtils_1.getObjectiveLocale)('Receiver')),
                            react_1.default.createElement("div", { className: "w-[166px]", ref: inlineDialogRef },
                                react_1.default.createElement("div", { className: `w-full min-h-[24px] ${user?.id !== owner?.id && 'cursor-pointer'}`, onClick: (e) => {
                                        e.stopPropagation();
                                        user?.id !== owner?.id && setShowDialog(!showDialog);
                                    } }, receivers?.length === 1 ? (react_1.default.createElement("div", { className: "flex item-center" },
                                    react_1.default.createElement(Avatar_1.default, { name: receivers[0]?.name, src: receivers[0]?.profilePicture, size: 24 }),
                                    react_1.default.createElement(TruncateParagraph_1.default, { className: "typography-paragraph text-n-900 max-w-[132px] ml-[8px]" }, receivers[0]?.name))) : (react_1.default.createElement(AvatarGroup_1.default, { avatars: receivers }))),
                                showDialog && (react_1.default.createElement(InlineDialogSelectMultipleUser_1.default, { selectedValue: selectedUsers, handleChange: handleChangeSelectedUsers, onCloseDialog: () => setShowDialog(false), position: "left", useTrigger: false, useFloating: true, floatingCustomHorizontalMargin: inlineDialogHorizontalMargin, presetSuggestions: user?.id === owner?.id ? [user] : [user, owner] }))))))),
            react_1.default.createElement(Modal_1.default.Footer, { primaryButton: {
                    text: (0, HelperUtils_1.getObjectiveLocale)('Export'),
                    onClick: () => onClickExport(),
                    isLoading: isLoading
                }, secondaryButton: {
                    text: (0, HelperUtils_1.getObjectiveLocale)('Cancel'),
                    onClick: () => setShowModal(false)
                }, useBorder: false })),
        !isLoading && showPreview && (react_1.default.createElement(ObjectiveProgressSummaryPreview_1.default, { owner: owner || user, receivers: receivers, overallProgress: overallProgress, parentObjective: parentObjective, objectives: objectives, setShowModal: setShowModal, setShowPreview: setShowPreview, setToast: setToast })),
        react_1.default.createElement(ToastNotif_1.default, { showNotif: showToastNotif, message: "Must select at least 1 receiver", warning: true, usePortal: true })));
};
exports.default = ObjectiveProgressSummaryModal;
